export default "__VITE_ASSET__07Y2hxdy__"